document.addEventListener('DOMContentLoaded', function () {
  var marquees = document.querySelectorAll('[data-cb-logo-marquee]');
  if (!marquees.length) return;

  marquees.forEach(function (marquee) {
    var track = marquee.querySelector('[data-marquee-track]');
    if (!track) return;

    function restartAnimation() {
      track.style.animation = 'none';
      track.offsetHeight;
      track.style.animation = '';
    }

    window.addEventListener('resize', restartAnimation);
  });
});